import { resolveValue, type Toast, ToastBar, Toaster } from 'react-hot-toast';

import styles from './_index.module.scss';

type NotificationStatus = 'error' | 'info' | 'success';

type NotificationToast = Toast & {
  status?: NotificationStatus;
};

const Notification = () => {
  return (
    <Toaster position="bottom-left" toastOptions={{ className: styles['notification'] }}>
      {(t: NotificationToast) => {
        const status = t.type === 'blank' ? t?.status || 'info' : t.type;

        return (
          <ToastBar toast={t}>
            {() => (
              <div className={styles['notification-content']}>
                <div className={styles[`is-${status}`]}>{resolveValue(t.message, t)}</div>
              </div>
            )}
          </ToastBar>
        );
      }}
    </Toaster>
  );
};

export default Notification;
